export const PurchaseStatusColor = [
  {
    label: 'Filter By Status',
    value: '0',
    class: '',
  },
  {
    label: 'New',
    value: '1',
    class: 'report--label-new',
  },
  {
    label: 'Ordered',
    value: '2',
    class: 'report--label-ordered',
  },
  {
    label: 'Received',
    value: '4',
    class: 'report--label-received',
  },
  {
    label: 'Confirmed',
    value: '5',
    class: 'report--label-confirmed',
  },
  {
    label: 'Verified',
    value: '7',
    class: 'report--label-verified',
  },
]
export const InvoiceStatusColor = [
  {
    label: 'Filter By Status',
    value: '0',
    class: '',
  },
  {
    label: 'New',
    value: '1',
    class: 'report--label-new',
  },
  {
    label: 'Locked',
    value: '2',
    class: 'report--label-locked',
  },
  {
    label: 'Loaded',
    value: '3',
    class: 'report--label-loaded',
  },
  {
    label: 'Returned',
    value: '4',
    class: 'report--label-returned',
  },
  {
    label: 'Balanced',
    value: '5',
    class: 'report--label-balanced',
  },
  {
    label: 'Verified',
    value: '7',
    class: 'report--label-verified',
  },
]

export const invoiceStatuses = InvoiceStatusColor.map((status) => {
  return {
    label: status.label,
    value: status.value,
  }
})

export const purchaseStatuses = PurchaseStatusColor.map((status) => {
  return {
    label: status.label,
    value: status.value,
  }
})
